import React from 'react'

const Testimonial = () => {
  return (
    <div></div>
  )
}

export default Testimonial